import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { ReferencedEntity } from '../../../../../domain/value-object/ReferencedEntity'
import { Autocomplete } from '../../../../components/inputs/Autocomplete'
import { TicketListAutocompleteProps } from '../model'

type TicketListAutocompleteCellProps = {
  value: ReferencedEntity | undefined
  onChange?: (v: ReferencedEntity | undefined) => void
} & TicketListAutocompleteProps &
  CellPropsBase

export const TicketListAutocompleteCell = ({
  cellWidth,
  label,
  help,
  value,
  onChange,
  options,
  onFocus,
  editable = true,
  required = false,
  edited,
  validationErrors,
  renderOption,
  renderInput,
  groupBy,
  renderGroupLabel,
  defaultExpandedGroups,
  popperWidth,
  listFooter,
}: TicketListAutocompleteCellProps) => (
  <FormCell cellWidth={cellWidth}>
    <CellTitle title={label} required={required} help={help} />
    <CellValueArea edited={edited} validationErros={validationErrors}>
      <Autocomplete
        value={value}
        onChange={onChange}
        options={options}
        onFocus={onFocus}
        disabled={!editable}
        renderOption={renderOption}
        renderInput={renderInput}
        groupBy={groupBy}
        renderGroupLabel={renderGroupLabel}
        defaultExpandedGroups={defaultExpandedGroups}
        popperWidth={popperWidth}
        listFooter={listFooter}
      />
    </CellValueArea>
  </FormCell>
)
